import React from 'react';
import { ExternalLink } from 'lucide-react';
import { FaGoogle } from 'react-icons/fa';
import { contactInfo } from '../data/mock';
import './Reviews.css';

const Reviews = ({ language }) => {
  return (
    <section>
      <div className="container">
        <div className="section-head">
          <h2>
            {language === 'en' 
              ? 'What Our Customers Say About Us!' 
              : '¡Lo Que Nuestros Clientes Dicen de Nosotros!'}
          </h2>
          <p>
            {language === 'en'
              ? 'Real reviews from real customers on Google. Your trust is our priority!'
              : '¡Reseñas reales de clientes reales en Google. Tu confianza es nuestra prioridad!'}
          </p>
          <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', marginTop: '1.5rem', flexWrap: 'wrap' }}>
            <a
              href={contactInfo.googleReviewsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-primary"
            >
              <FaGoogle size={20} />
              {language === 'en' ? 'Leave a Google Review' : 'Dejar Reseña en Google'}
            </a>
            <a
              href={contactInfo.googleReviewsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-secondary"
            >
              <ExternalLink size={20} />
              {language === 'en' ? 'View All Reviews' : 'Ver Todas las Reseñas'}
            </a>
          </div>
        </div>

        {/* Google Reviews Widget Placeholder */}
        <div className="google-reviews-widget">
          <div className="reviews-placeholder">
            <FaGoogle size={64} style={{ color: '#4285f4', marginBottom: '1rem' }} />
            <h3>
              {language === 'en' 
                ? 'Google Reviews' 
                : 'Reseñas de Google'}
            </h3>
            <p>
              {language === 'en'
                ? 'To display real Google reviews here, configure your Google Business Profile ID in the settings.'
                : 'Para mostrar reseñas reales de Google aquí, configura tu ID de Perfil de Negocio de Google en la configuración.'}
            </p>
            <div className="rating-display">
              <div className="stars-large">★★★★★</div>
              <p style={{ fontSize: '1.2rem', fontWeight: 'bold', color: 'var(--ink)', margin: '0.5rem 0' }}>
                5.0 {language === 'en' ? 'Rating' : 'Calificación'}
              </p>
              <p style={{ color: 'var(--ink-soft)' }}>
                {language === 'en' ? 'Based on Google Reviews' : 'Basado en Reseñas de Google'}
              </p>
            </div>
            <a
              href={contactInfo.googleReviewsUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="view-google-link"
            >
              <FaGoogle size={18} />
              {language === 'en' ? 'View on Google' : 'Ver en Google'}
            </a>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: '2rem', padding: '1.5rem', background: '#f8fdff', borderRadius: '20px' }}>
          <p style={{ color: 'var(--ink-soft)', fontSize: '0.95rem', margin: 0 }}>
            {language === 'en'
              ? '💡 To integrate live Google Reviews: Update the googleReviewsUrl in mock.js with your Google Business Profile link'
              : '💡 Para integrar Reseñas de Google en vivo: Actualiza googleReviewsUrl en mock.js con tu enlace de Perfil de Negocio de Google'}
          </p>
        </div>
      </div>
    </section>
  );
};

export default Reviews;
